module.exports = __webpack_public_path__ + "img/edit-slate-icon-green.aa5ad90b.svg";